export const maskEmail = email => {
  if (!email.includes('@')) {
    return `****@****`;
  }

  let maskedUsername = '****';
  let maskedDomain = '****';
  const [username = '', domain = ''] = email.split('@');

  if (username.length >= 4) {
    maskedUsername = `${username[0]}***`;
  }

  const subdomains = domain.split('.');

  if (domain.length >= 4 && subdomains.length >= 2) {
    const firstSubdomain = subdomains[0];
    const topLevelDomain = subdomains[subdomains.length - 1];
    maskedDomain = `${firstSubdomain[0]}***.${topLevelDomain}`;
  }

  return `${maskedUsername}@${maskedDomain}`;
};
export const flattenObj = obj => {
  const flattened = {};

  const flattenProp = (value, prefix = '') => {
    const type = Object.prototype.toString.call(value);

    if (type === '[object Object]') {
      for (const [k, v] of Object.entries(value)) {
        flattenProp(v, `${prefix}${prefix === '' ? '' : '.'}${k}`);
      }
    } else if (Array.isArray(value)) {
      value.forEach((v, ix) => {
        flattenProp(v, `${prefix}[${ix}]`);
      });
    } else {
      flattened[prefix] = value;
    }
  };

  flattenProp(obj);
  return flattened;
};
export const objectifyError = error => {
  const err = {
    message: error.message,
    name: error.name,
    stack: error.stack
  };

  for (const key in error) {
    if (Object.prototype.hasOwnProperty.call(error, key)) {
      err[key] = error[key];
    }
  }

  return err;
};
export const isIframe = () => window.self !== window.top;
export const normalizeOrigins = origins => origins.map(origin => {
  try {
    const url = new URL(origin);
    return url.protocol === 'http:' || url.protocol === 'https:' ? url.origin : undefined;
  } catch {
    return undefined;
  }
}).filter(origin => Boolean(origin));
export const resolveAllowedParentOrigin = (allowedOrigins, candidates, fallback) => {
  const normalizedAllowed = normalizeOrigins(allowedOrigins);

  for (const candidate of candidates) {
    if (!candidate) continue;
    let candidateOrigin;

    try {
      candidateOrigin = new URL(candidate).origin;
    } catch {
      continue;
    }

    if (normalizedAllowed.includes(candidateOrigin)) {
      return candidateOrigin;
    }
  }

  return fallback;
};
export function defaultDict(initializer) {
  const handler = {
    get(target, prop) {
      if (Reflect.has(target, prop)) {
        return target[prop];
      }

      target[prop] = initializer();
      return target[prop];
    }

  };
  return new Proxy({}, handler);
}
export const isIOSDevice = () => typeof window !== 'undefined' && /iPad|iPhone/.test(navigator.userAgent);
export const isAndroidDevice = () => typeof window !== 'undefined' && /Android/i.test(navigator.userAgent);